// Real Admin API — /api/V1/Admin/* (role-2 endpoints). Signatures mirror
// adminMock.ts so api/index.ts swaps mock ↔ real with one switch.

import { postJson } from './http';
import type {
  AdminAgent,
  AdminUserDetail,
  AdminUserFormValues,
  AdminUserListParams,
  AdminUserSummary,
  Organization,
  ReportItem,
  ReportParams,
  SaveResult,
} from '@/types/api';

const API = '/api/V1';

export const adminRealApi = {
  async getOrganizations(): Promise<Organization[]> {
    const res = await postJson<{ err: string; data?: Organization[] }>(`${API}/Admin/Organizations`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async listAgents(): Promise<AdminAgent[]> {
    const res = await postJson<{ err: string; data?: AdminAgent[] }>(`${API}/Admin/Agents`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async listAdminUsers(params: AdminUserListParams = {}): Promise<{ rows: AdminUserSummary[]; total: number }> {
    const res = await postJson<{ err: string; data?: AdminUserSummary[]; total?: number }>(`${API}/Admin/Users/List`, { ...params });
    return { rows: res.err === '1' && Array.isArray(res.data) ? res.data : [], total: res.total ?? 0 };
  },

  async getAdminUser(id: number): Promise<AdminUserDetail | null> {
    const res = await postJson<{ err: string; data?: AdminUserDetail }>(`${API}/Admin/Users/Get`, { id });
    return res.err === '1' && res.data ? res.data : null;
  },

  async createAdminUser(values: AdminUserFormValues): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Admin/Users/Create`, { ...values });
  },

  async updateAdminUser(id: number, values: AdminUserFormValues): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Admin/Users/Update`, { id, ...values });
  },

  async removeAdminUser(id: number): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Admin/Users/Remove`, { id });
  },

  async listReport(params: ReportParams = {}): Promise<ReportItem[]> {
    const res = await postJson<{ err: string; data?: ReportItem[] }>(`${API}/Admin/Report/List`, { ...params });
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async markPaid(id: number, mid: number): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Admin/Report/MarkPaid`, { id, mid });
  },
};
